import {Component, OnInit} from '@angular/core';
import {NotificationsService} from "angular2-notifications";
import {Router} from "@angular/router";
import {UserService} from "../services/user.service";
import {SecuirtyService} from "../services/secuirty.service";
import {NgForm} from "@angular/forms";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
    selector: 'app-secuirties',
    templateUrl: './secuirties.component.html',
    styleUrls: ['./secuirties.component.css']
})
export class SecuirtiesComponent implements OnInit {
    emailObj = {
        _id: '',
        email: false,
        status: false,
        code: '',
        order: '',
        authkey: null,
        _csrf: '',
    }
    smsObj = {
        _id: '',
        sms: false,
        status: false,
        order: '',
        code: '',
        authkey: null,
        _csrf: '',
    }

    twofaObj = {
        _id: '',
        twofa: false,
        status: false,
        order: '',
        code: '',
        enabled: false,
        qrcode: '',
        secret: '',
        _csrf: '',
    }
    userapikeys = [];
    apikeyObj = {
        label: '',
        endpoints: {},
        _csrf: ''
    }
    endpointsList = [];
    endpointAccess = {};
    keylistpanel = false;
    keyformpanel = false;
    permissionmodel = 'none';
    editKeyObj = {
        label: '',
        _id: '',
        key: '',
        status: '',
        _csrf: '',
        endpoints: {},
    }
    editkeyForm = false;

    constructor(private userService: UserService,
                private notif: NotificationsService,
                private securityService: SecuirtyService,
                private router: Router,
                private spinnerService: Ng4LoadingSpinnerService) {
    }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.csrf();
            this.getGenerateKey();
        }
    }
    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.twofaObj._csrf = success._csrf;
            this.emailObj._csrf = success._csrf;
            this.smsObj._csrf = success._csrf;
            this.apikeyObj._csrf = success._csrf;
            this.editKeyObj._csrf = success._csrf;
        }, (error) => {
            console.log(error)
            this.notif.error(
                'Error',
                error.error.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    // getGenerateKey
    getGenerateKey() {
        this.securityService.getGenerateKey().subscribe((success) => {
            this.userapikeys = success['apikey'];
            this.endpointsList = success['endpoints'];
            this.endpointAccess = success['access']
        }, (error) => {
            this.notif.error(
                'Error',
                error.error.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    generateApiKey(form: NgForm) {
        this.spinnerService.show();
        this.securityService.generateKey(this.apikeyObj).subscribe((success) => {
            this.spinnerService.hide();
            this.notif.success(
                'Generate Key',
                success.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.csrf();
            this.getGenerateKey();
            this.keylistpanel = true;
            form.reset();
        }, (error) => {
            this.csrf();
            this.spinnerService.hide();
            this.notif.error(
                'Generate Key',
                error.error.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    deleteKey(id) {
        this.spinnerService.show();
        this.securityService.deleteAPIKey(id).subscribe((success) => {
            this.HidePermission();
            this.notif.success(
                'Delete API Key',
                success.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.getGenerateKey();
            this.keylistpanel = true;
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notif.error(
                'Delete API Key',
                error.error.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    ShowPermission(item) {
        this.editkeyForm = false;
        this.editKeyObj = {
            label: '',
            _id: '',
            key: '',
            status: '',
            _csrf: '',
            endpoints: {},
        }
        this.csrf();
        this.editKeyObj._id = item._id;
        this.editKeyObj.label = item.label;
        this.editKeyObj.key = item.key;
        this.editKeyObj.status = item.status;
        this.endpointsList.forEach((endp) => {
            if (this.endpointAccess[item._id + '_' + endp._id]) {
                this.editKeyObj.endpoints[endp._id]= this.endpointAccess[item._id + '_' + endp._id].access;
            }
        });
        setTimeout(() => {
            this.checkAllMenu2();
        }, 1)
        this.permissionmodel = 'block';
    }

    checkAllMenu2() {
        var checkboxes = document.getElementsByTagName('input')
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].type === 'checkbox') {
                if (Object.keys(this.editKeyObj.endpoints).indexOf(checkboxes[i].getAttribute('value')) !== -1) {
                    checkboxes[i].checked = true;
                    //this.editKeyObj.endpoints = this.arrayRemove(this.editKeyObj.endpoints, checkboxes[i].getAttribute('value'));
                    delete this.editKeyObj.endpoints[checkboxes[i].getAttribute('value')];
                    this.editKeyObj.endpoints[checkboxes[i].getAttribute('value')]= true;
                    //this.editKeyObj.endpoints.push(checkboxes[i].getAttribute('value'))
                } else {
                    checkboxes[i].checked = false;
                }
            }
        }
    }
    checkParentMenuUpdate(element,id){
        var currentElement = document.getElementById('editendpnt'+id) as HTMLInputElement;
        if(element.target.checked){
            delete this.editKeyObj.endpoints[id];
            this.editKeyObj.endpoints[id]= true;
            //this.editKeyObj.endpoints=this.arrayRemove(this.editKeyObj.endpoints,id);
            //this.editKeyObj.endpoints.push(id);
            currentElement.checked = true;
        }else{
            //this.editKeyObj.endpoints=this.arrayRemove(this.editKeyObj.endpoints,id);
            delete this.editKeyObj.endpoints[id];
            currentElement.checked = false;
        }
    }
    editAPIKey(){
        this.editkeyForm = true;
        setTimeout(() => {
            this.checkAllMenu2();
        }, 1)

    }
    HidePermission() {
        this.permissionmodel = 'none';
    }
    UpdateApiKey(form: NgForm){
        this.spinnerService.show();
        this.securityService.updategenerateKey(this.editKeyObj).subscribe((success) => {
            this.HidePermission();
            this.notif.success(
                'Update Generate Key',
                success.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.csrf();
            this.getGenerateKey();
            this.keylistpanel = true;
            this.spinnerService.hide();
        }, (error) => {
            this.csrf();
            this.spinnerService.hide();
            this.notif.error(
                'Update Generate Key',
                error.error.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    copyMessage(val: string){
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
}




// WEBPACK FOOTER //
// ./src/app/secuirties/secuirties.component.ts